import useBaseAPI from './useBaseAPI';

const useApplicationAPI = () => {
  const { client, isLoading } = useBaseAPI();

  const getApplications = async () => {
    try {
      const response = await client('get', '/application/');
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getApplication = async (applicationId) => {
    try {
      const response = await client('get', `/application/${applicationId}`);
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const addApplication = async (payload) => {
    try {
      const response = await client('post', '/application', payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const updateApplication = async (applicationId, payload) => {
    try {
      const response = await client('post', `/application/${applicationId}`, payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const deleteApplication = async (applicationId) => {
    try {
      const response = await client('delete', `/application/${applicationId}`);
      return response?.success;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    getApplications,
    getApplication,
    addApplication,
    deleteApplication,
    updateApplication,
    isLoading,
  };
};

export default useApplicationAPI;
